import { uuid } from 'uuidv4';

import {
  IngestionSourceModelOutput,
  IngestionSourceParametersOutput,
  IngestionSourceParametersType,
  IngestionSourceStatus,
  IngestionStageType,
  WebsiteSourceParametersReceivingMode,
  WebsiteSourceParametersSettings,
} from '../../../../gamma-api';

export const generateExternalId = (): string => uuid().toString();

export const hasSourceStatus = (source: IngestionSourceModelOutput, ...status: IngestionSourceStatus[]): boolean => {
  for (const item of status) {
    if (source.status == item) {
      return true;
    }
  }

  return false;
};

export const getStageProgress = (stage?: IngestionStageType): number => {
  if (
    stage === IngestionStageType.Prefetch ||
    stage === IngestionStageType.Loading ||
    stage === IngestionStageType.Savepoint
  ) {
    return 0;
  }

  if (stage === IngestionStageType.Extraction) {
    return 1;
  }

  if (stage === IngestionStageType.Parsing) {
    return 2;
  }

  if (stage === IngestionStageType.Embedding) {
    return 3;
  }

  if (stage === IngestionStageType.Indexing) {
    return 4;
  }

  return 5;
};

export const isCrawlerSource = (parameters: IngestionSourceParametersOutput): boolean => {
  return (
    parameters.type == IngestionSourceParametersType.WebsiteCrawler ||
    (parameters.type == IngestionSourceParametersType.Website &&
      (parameters.settings as WebsiteSourceParametersSettings).receiving_mode ==
        WebsiteSourceParametersReceivingMode.Crawler)
  );
};

export const isCancelableStage = (stage?: IngestionStageType | null): boolean => {
  if (!stage) {
    return false;
  }

  const stages: IngestionStageType[] = [
    IngestionStageType.Prefetch,
    IngestionStageType.Loading,
    IngestionStageType.Extraction,
    IngestionStageType.Parsing,
    IngestionStageType.Embedding,
  ];
  return stages.includes(stage);
};

export const isSourcePreviewing = (source: IngestionSourceModelOutput): boolean => {
  const status: IngestionSourceStatus[] = [];

  if (source.versions.latest.source.instruction.stages[IngestionStageType.Savepoint]) {
    status.push(IngestionSourceStatus.Pending);
    status.push(IngestionSourceStatus.Preparing);
  }

  status.push(IngestionSourceStatus.Prefetch);

  if (isCrawlerSource(source.versions.latest.source.parameters)) {
    status.push(IngestionSourceStatus.Loading);
  }

  status.push(IngestionSourceStatus.Savepoint);
  status.push(IngestionSourceStatus.Previewed);
  status.push(IngestionSourceStatus.Built);

  return hasSourceStatus(source, ...status);
};

export const isSourceBuilding = (source: IngestionSourceModelOutput): boolean => {
  const status: IngestionSourceStatus[] = [];

  if (source.versions.latest.source.instruction.stages[IngestionStageType.Commit]) {
    status.push(IngestionSourceStatus.Pending);
    status.push(IngestionSourceStatus.Preparing);
  }

  if (!isCrawlerSource(source.versions.latest.source.parameters)) {
    status.push(IngestionSourceStatus.Loading);
  }

  status.push(IngestionSourceStatus.Extraction);
  status.push(IngestionSourceStatus.Parsing);
  status.push(IngestionSourceStatus.Embedding);
  status.push(IngestionSourceStatus.Indexing);
  status.push(IngestionSourceStatus.Deletion);
  status.push(IngestionSourceStatus.Commit);
  status.push(IngestionSourceStatus.Rollback);

  return hasSourceStatus(source, ...status);
};
